import { render, staticRenderFns } from "./SaveTemplate.vue?vue&type=template&id=5b30d619&"
import script from "./SaveTemplate.vue?vue&type=script&lang=js&"
export * from "./SaveTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports